import { Component, h } from '@stencil/core';
import { getCustomerReview } from '@ugc-api/review';
import state from '@ugc-store';
import { login, showToast } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-write-review-button',
  shadow: false,
})
export class UgcWriteReviewButton {
  async getVerifyCustomerReviewData() {
    try {
      await getCustomerReview(state.productInfo.productId);
      return 200;
    } catch (e) {
      return e.status;
    }
  }

  async handleWriteReviewButtonClick() {
    const { isLogin } = state;
    if (!isLogin) {
      login();
      return;
    }
    const res = await this.getVerifyCustomerReviewData();
    if (res === 200) {
      window.location.href = `/ugc/product/${state.productInfo.productId}/review`;
      return;
    }
    if (res === 401) {
      login();
      return;
    }
    const {
      reviewStaticLanguage: { IDS_UGC_NOT_ELIGIBLE_FOR_REVIEW = '', IDS_UGC_UNEXPECTED_ERROR = '' } = {},
    } = state;
    if (res === 403) {
      showToast({
        type: 'error',
        message: [IDS_UGC_NOT_ELIGIBLE_FOR_REVIEW || ''],
      });
      return;
    }
    showToast({
      type: 'error',
      message: [IDS_UGC_UNEXPECTED_ERROR || ''],
    });
  }
  render() {
    const {
      isDesktop,
      productInfo: { productId },
      actionPermission: { review: reviewButtonDisabled },
      reviewStaticLanguage: { IDS_UGC_REVIEW_WRITE_A_REVIEW = '', IDS_MY_REVIEW_UPDATE_MY_REVIEW = '' } = {},
      isUpdateReview,
      ids,
      isShowReviewSkeleton,
    } = state;

    if (isShowReviewSkeleton) return null;
    if (!ids.length && isDesktop) return null;

    if (isDesktop)
      return (
        !reviewButtonDisabled && (
          <a href={`/ugc/product/${productId}/review`} class="mt-16 block">
            <ugc-button height="48" fontSize="16">
              {isUpdateReview ? IDS_MY_REVIEW_UPDATE_MY_REVIEW : IDS_UGC_REVIEW_WRITE_A_REVIEW}
            </ugc-button>
          </a>
        )
      );
    return (
      <div class="mt-16">
        <ugc-button
          height="48"
          fontSize="16"
          disabled={reviewButtonDisabled}
          onClick={() => this.handleWriteReviewButtonClick()}
        >
          {isUpdateReview ? IDS_MY_REVIEW_UPDATE_MY_REVIEW : IDS_UGC_REVIEW_WRITE_A_REVIEW}
        </ugc-button>
      </div>
    );
  }
}
